<template>
    <v-tab-item class="fill-height">
        <div class="text-center mb-20 mb-lg-40">
            <h3 class="tit mb-8 mb-lg-16">생성된 시간 확인</h3>
            <p class="page-text--lg grey-6--text">생성된 시간을 확인한 후 면접 가능 시간이 맞으면 다음 단계로 넘어가 주세요.</p>
        </div>
        <v-card rounded="lg" outlined>
            <div class="pa-20 pa-md-30 pa-lg-40">
                <meeting-schedules-card :meeting="value" />
            </div>
        </v-card>
        <div class="v-btn-group">
            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('prev')">
                <span class="grey-6--text">이전으로</span>
            </v-btn>
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="$emit('save')">
                <span>저장 후 다음으로</span>
            </v-btn>
        </div>
        <!-- <v-layout column align-center fill-height style="overflow-y: hidden">
            <v-card-title class="font-size-26 font-size-md-30 font-size-lg-36">생성된 시간 확인</v-card-title>
            <v-card-subtitle class="page-text--lg pt-16 pb-40 grey-6--text">생성된 시간을 확인한 후 면접 가능 시간이 맞으면 다음 단계로 넘어가 주세요.</v-card-subtitle>
            <v-card-text class="d-flex flex-column" style="position: relative; flex: 1 1 auto; overflow-y: hidden">
                <meeting-schedules-card :meeting="value" />
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn outlined @click="$emit('prev')"> 이전으로</v-btn>
                <v-btn color="primary" v-bind="{ loading }" @click="$emit('save')"> 저장 후 다음으로 </v-btn>
            </v-card-actions>
        </v-layout> -->
    </v-tab-item>
</template>

<script>
import { initMeeting } from "@/assets/variables";

import MeetingSchedulesCard from "@/components/dumb/meeting-schedules-card.vue";

export default {
    components: {
        MeetingSchedulesCard,
    },
    props: {
        value: { type: Object, default: initMeeting }, // meeting
        loading: { type: Boolean, default: false },
    },
};
</script>
